import { useState, useEffect, useRef } from "react";
import Play from "./icons/play";
import Pause from "./icons/pause";

export const AudioPlayer = ({ data }) => {
  const audioRef = useRef(null);
  const playButtonRef = useRef(null);
  const timeRef = useRef(null);
  const [progress, setProgress] = useState(0); 
  const [playing, setPlaying] = useState(false); 

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller; 

    audioRef.current.addEventListener(
      "timeupdate",
      () => {
        const currentTime = audioRef.current.currentTime;
        const duration = audioRef.current.duration;
        timeRef.current.textContent = `${formatTime(currentTime)} / ${formatTime(duration)}`;
        setProgress((currentTime / duration) * 100);
      },
      { signal }
    );

    return () => controller.abort();
  }, []); 

  const formatTime = (seconds) => {
    if (isNaN(seconds)) return "0:00";
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handlePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      audio.play();
      setPlaying(true);
    } else {
      audio.pause();
      setPlaying(false);
    }
  };

  const handleProgress = (e) => {
    const audio = audioRef.current;
    const val = Number(e.target.value);
    setProgress(val);
    audio.currentTime = (val / 100) * audio.duration;
  };

  if (!data || Object.keys(data).length === 0) return null;

  return (
    <div className="audio-player">
      <audio id="podcastAudio" src={data.audio_preview_url} ref={audioRef} />
      <div className="audio-player__timerbox">
        <button 
          id="playBtn" 
          ref={playButtonRef} 
          onClick={handlePlay} 
          className="audio-player__button"
        >
          {playing ? <Pause color="black" width={20} height={20} /> : <Play bgColor="white" color="black" width={32} height={32} justIcon={true} /> }
        </button>
        <span id="time" ref={timeRef} style={playing ? { color: 'white' } : {}}>0:00 / 0:00</span>
      </div>
      <input
        type="range"
        id="progress"
        value={progress} 
        onChange={handleProgress}
        style={{
          background: `linear-gradient(90deg, white ${progress}%, rgba(43, 98, 105, 0.8) ${progress}%)`,
        }}
      />
    </div>
  );
};
